export default {
    sms: 'សេវាសារ SMS',
    sms_management: 'ការគ្រប់គ្រងសារ SMS',
    create_sms: 'បង្កើតសារ SMS',
    create_new_sms: 'SMS ថ្មី',
    schedule: 'តារាងពេល',
    brand_names: 'ឈ្មោះ​ម៉ាក',
    manual: 'សៀវភៅណែនាំអ្នកប្រើប្រាស់',
    web_tool: 'ឧបករណ៍បណ្តាញ',
    sms_brand_name: 'ឈ្មោះម៉ាក SMS',
    new_brand_name: 'ឈ្មោះម៉ាកថ្មី។',
    create_template: 'បង្កើតគំរូ',
    update_template: 'អាប់ដេតគំរូ',
    sms_info: {
        1: 'ជាមួយនឹងសេវាកម្ម SMS Brandname របស់ 1Byte អ្នកអាចផ្តល់សេវាកម្មអតិថិជន និងសារផ្សាយពាណិជ្ជកម្មបានយ៉ាងងាយស្រួល។',
        2: 'ឈ្មោះម៉ាក៖ អ្វីដែលនឹងត្រូវបានបង្ហាញជាប្រធានបទនៃសារ SMS មិនគួរវែងជាង ១១ តួអក្សរ និងមានឈ្មោះដូចគ្នាទៅនឹងអាជីវកម្មរបស់អ្នក',
    },
    brand_name: 'ឈ្មោះ​យីហោ',
    company_name: '(ឈ្មោះ​ក្រុម​ហ៊ុន)',
    reg_date: 'កាលបរិច្ឆេទចុះឈ្មោះ',
    description: 'ការបរិយាយ',
    brand_name_list: 'បញ្ជីឈ្មោះម៉ាក',
    update_brand_name: 'អាប់ដេតម៉ាកយីហោ',
    modal_register_title: 'ចុះឈ្មោះដោយប្រើ SMS Brandname',
    modal_register_title_confirm: 'បញ្ជាក់ឈ្មោះម៉ាក SMS',
    upload_file: 'ផ្ទុកឯកសារឡើង',
    attach_file: 'ភ្ជាប់ឯកសារ',
    full_name: 'ឈ្មោះ​ពេញ',
    phone_number: 'លេខទូរសព្ទ',
    date_of_birth: 'ថ្ងៃខែ​ឆ្នាំ​កំណើត',
    birthday: 'ថ្ងៃកំណើត',
    group_name: 'ឈ្មោះ​ក្រុម',
    accept_type:
        'សូមបង្ហាប់ និងបង្ហោះការចុះឈ្មោះវិញ្ញាបនបត្រអាជីវកម្មរបស់អ្នកក្រោមទម្រង់ .zip ឬ .rar',
    register_brand_name: 'ចុះឈ្មោះម៉ាកយីហោ',
    number_of_sms: 'ចំនួន SMS',
    unit: 'ឯកតា',
    khmer: 'ខ្មែរ',
    vietnam: 'វៀតណាម',
    vietnamese: 'វៀតណាម',
    chinese: 'ចិន',
    english: 'ភាសាអង់គ្លេស',
    character: 'តួអក្សរ',
    note: 'ចំណាំ',
    sms_rule_title: {
        kh: 'ប្រវែងសារជាភាសាខ្មែរ អង់គ្លេស វៀតណាម និងចិន',
    },
    sms_rules_note: {
        1: 'ខ្លឹមសារនៃសារ៖ គ្មានការបៀតបៀនផ្លូវភេទ នយោបាយ ឬសាសនា ការផ្សាយពាណិជ្ជកម្មរបស់ដៃគូប្រកួតប្រជែង',
        2: 'ប៉ុស្តិ៍ត្រួតពិនិត្យ៖ ប្រព័ន្ធនឹងពិនិត្យមាតិកាដោយស្វ័យប្រវត្តិ មុនពេលផ្ញើសារថែទាំអតិថិជន។ សម្រាប់សារផ្សាយ',
        3: 'ក្រោយអធិការកិច្ច៖ បើសារមិនត្រឹមត្រូវជាមួយនឹងការចាត់ថ្នាក់ប្រភេទ និងបទប្បញ្ញត្តិសារ នាយកដ្ឋានផលិតផល',
    },
    existing_template: 'គំរូដែលមានស្រាប់',
    category: 'ប្រភេទ',
    subject: 'ប្រធានបទ',
    content: 'ខ្លឹមសារ',
    confirm_delete_text: 'តើអ្នកប្រាកដថាចង់លុបគំរូ SMS មែនទេ?',
    confirm_delete_title: 'បញ្ជាក់',
    modal_create_template_title: 'បង្កើតគំរូថ្មី។',
    modal_edit_template_title: 'កែសម្រួលគំរូ',
    characters_left: 'តួអក្សរដែលនៅសេសសល់រហូតដល់ការរាប់សារ SMS បន្ទាប់',
    number_sms: 'ចំនួន SMS',
    modal_import_csv_title: {
        step_1: 'នាំចូលបញ្ជីពីឯកសារ CSV',
        step_2: 'កំពុងពិនិត្យទិន្នន័យ',
        step_3_checking: 'Checking data',
        step_3: 'សូមពិនិត្យម្តងទៀត',
        step_4: 'បញ្ជីអតិថិជន',
    },
    create_sms_form: {
        label: 'ផ្ញើសារ SMS',
        brand_name: 'ឈ្មោះ​យីហោ',
        subject_label: 'ប្រធានបទ',
        content_label: 'ខ្លឹមសារ',
        sender_brandname_placeholder: 'ជ្រើសរើសម៉ាកយីហោ',
    },
    create_sms_step2: {
        receiver_label: 'អ្នកទទួល',
        schedule_label: 'តារាងពេល',
        customer_group_label: 'ក្រុម',
        customer_group_import_label: 'បញ្ជីនាំចូលពី CSV',
        customer_group_download_label: 'ទាញយកគំរូ',
        customer_group_hint: {
            part1: 'ឯកសារ CSV មានជួរឈរបីតាមលំនាំដើម៖',
            part2: 'ឈ្មោះពេញ លេខទូរស័ព្ទត្រូវតែចាប់ផ្តើមដោយ ០ ឬ +៨៥៥',
            read_more_rule: 'អានច្បាប់ទូរស័ព្ទបន្ថែម។',
            part3: 'និងថ្ងៃខែឆ្នាំកំណើត (DD/MM/YYYY)។',
        },
        phone_rule_modal: {
            title: 'តារាងលេខបុព្វបទទូរសព្ទនៅកម្ពុជា',
            note: 'បុព្វបទដែលមានសញ្ញាផ្កាយ (*) គឺជាលេខ ៧ ខ្ទង់',
            button_text: 'យល់ព្រម',
        },
        customers: {
            title: 'អតិថិជន',
        },
    },
    modal_import_csv_content: {
        step_1: {
            title: 'ជំហានទី 1 នៃ 2: ផ្ទុកឯកសារឡើង',
            hint: 'ឯកសារ CSV មានជួរឈរបីតាមលំនាំដើម ឈ្មោះពេញ លេខទូរស័ព្ទ និងថ្ងៃខែឆ្នាំកំណើត',
        },
        step_2: {
            title: 'ជំហានទី 2 នៃ 2៖ ផែនទីក្នុង CSV ដែលមានជួរឈរក្នុងតារាងអតិថិជន',
        },
        step_3: {
            invalid:
                'លេខទូរស័ព្ទមិនត្រឹមត្រូវ ឬទទេនៅក្នុងឯកសារ CSV ។ សូមពិនិត្យឯកសារ #C4, #A6 ម្តងទៀត',
            duplicate: {
                text_1: 'លេខទូរស័ព្ទ',
                text_2: 'ត្រូវបានចម្លង! តើអ្នកចង់ដកចេញទេ?',
            },
        },
    },
    select_column_placeholder: 'ជ្រើសរើសទម្រង់ទិន្នន័យ CSV',
    customer_error:
        'ទិន្នន័យដែលបាននាំចូលមិនត្រឹមត្រូវទេ សូមពិនិត្យមើលកំណត់ត្រាខាងក្រោម៖',
    duplicate_phone_message: {
        1: 'លេខទូរស័ព្ទ',
        2: 'ត្រូវបានចម្លង! តើអ្នកចង់ដកចេញទេ?',
    },
    receiver_details: 'ព័ត៌មានលម្អិតអំពីអ្នកទទួល',
    schedule_detail: 'តារាងពេលលម្អិត',
    sms_type: 'ប្រភេទ SMS',
    receiver: 'អ្នកទទួល',
    id: 'លេខសម្គាល់',
    total_of_sms: 'សរុបនៃសារ SMS',
    total_sent: 'សរុបបានផ្ញើ',
    created_date: 'កាលបរិច្ឆេទបង្កើត',
    date: 'កាលបរិច្ឆេទ',
    status: 'ស្ថានភាព',
    action: 'សកម្មភាព',
    search_place_holder: 'លេខសម្គាល់ ប្រធានបទ ខ្លឹមសារ ឈ្មោះម៉ាក',
    status_sms: 'ស្ថានភាព SMS',
    sms_amount_from: 'សរុបនៃសារ SMS ពី',
    sms_detail: 'ព័ត៌មានលម្អិត SMS',
    details: 'ព័ត៌មានលម្អិត',
    total_price: 'តម្លៃសរុប',
    export_report: 'របាយការណ៍នាំចេញ',
    total_sent_detail: 'ព័ត៌មានលម្អិតដែលបានផ្ញើ',
    form_schedule: {
        send_before: 'ផ្ញើមុន។',
        days: 'ថ្ងៃ',
        at: 'នៅ',
    },
    customer_list: 'បញ្ជីអតិថិជន',
    empty_birthday_error: 'ថ្ងៃខែឆ្នាំកំណើតទទេ។ សូមពិនិត្យមើលឯកសារម្តងទៀត!',
    empty_birthday_error_warning:
        'បញ្ជីអតិថិជននៅតែបាត់ថ្ងៃខែឆ្នាំកំណើត តើអ្នកចង់បិទការលេចឡើងទេ?',
    amount_sms_from_to: 'សរុបចាប់ផ្តើមនៃសារ SMS ត្រូវតែតិចជាងការបញ្ចប់',
    birthday_message: 'សារខួបកំណើត',
    now: 'ឥឡូវ​នេះ',
    no_event_display: 'គ្មានព្រឹត្តិការណ៍ដែលត្រូវបង្ហាញទេ',
    type: 'ប្រភេទ',
    brand_name_types: {
        international: 'អន្តរជាតិ',
        cambodia: 'កម្ពុជា',
    },
    send_results: 'ផ្ញើលទ្ធផល',
    pending: 'Pending',
    summary: 'សង្ខេប',
    go_to_this_transaction: 'ចូលទៅកាន់ប្រតិបត្តិការនេះ',
    confirm_cancel_text: {
        sms: 'តើអ្នកប្រាកដថាចង់លុបចោលប្រតិបត្តិការ SMS នេះទេ?',
        schedule: 'តើអ្នកប្រាកដថាចង់លុបចោលកាលវិភាគ SMS នេះទេ?',
    },
    list_sms_failures: 'បញ្ជីសារ SMS បរាជ័យ',
    sms_service_trial: 'ការសាកល្បងសេវាកម្មផ្ញើសារ SMS',
    sms_service_trial_content_title: 'មាតិកានឹងត្រូវបានផ្ញើ',
    try_demo_note:
        'លេខទូរស័ព្ទត្រូវតែចាប់ផ្តើមដោយលេខ 0 ឬ +855 អ្នកអាចអានបន្ថែមអំពីរបៀបប្រើប្រាស់ {here}',
};
